import React from 'react';

function PasswordResetSent({ email, onBack }) {
	return (
		<div className="login-secondary-form">
			<div>
				<h2 className="login-secondary-title">Check your inbox</h2>
				<p className="login-secondary-body">
					We've sent a password reset link to <strong>{email}</strong>. Follow the link to set a new password. If you don't see it, check your spam folder.
				</p>
			</div>
			<button type="button" className="login-back-btn" onClick={onBack}>
				Back to sign in
			</button>
		</div>
	);
}

export default PasswordResetSent;
